export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    fixed: 'left',
    align: 'center',
    width: 60,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_fabric_information') || '面料信息',
    field: 'fabricInfo',
    align: 'left',
    minWidth: 160,
    slots: { default: 'fabricInfo' },
  },
  {
    title: that.$l('form_label_expenseType') || '费用项目',
    field: 'expenseType',
    align: 'left',
    headerAlign: 'center',
    minWidth: 150,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'expenseType' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: "mini"
      },
    },
  },
  {
    title: that.$l('item_label_orgDepFullName') || '分摊部门',
    field: 'orgDepFullName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    editRender: { enable: true },
    slots: { edit: 'depCode' },
  },

  {
    field: 'unitPrice',
    minWidth: 80,
    title: that.$l('table_label_priceInfo') || '单价',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'requestQuantity',
    minWidth: 100,
    title: that.$l('INDEX.quantity') || '数量',
    headerAlign: 'center',
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 999999.99,
        step: 0.01,
        controls: false
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    field: 'fabricUnit',
    minWidth: 100,
    title: that.$l('table_label_fabricUnit') || '单位',
    headerAlign: 'center',
    align: 'center',
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'fabricYarnUnit' },
        url: '/digitalCenter/common/dict/biz',
        filterable: true,
        clearable: true,
        size: "mini"
      },
    },
  },

  {
    title: that.$l('table_label_fabricAmount') || '面料金额',
    field: 'requestAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999.99,
        step: 0.01,
        controls: false,
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    field: 'requestFee',
    minWidth: 100,
    title: that.$l('table_label_requestFee') || '附加费',
    headerAlign: 'center',
    align: 'center',
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 999999999.99,
        step: 0.01,
        controls: false
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_currencyAmount') || '费用合计',
    field: 'currencyAmount',
    align: 'center',
    width: 100,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_billCount') || '单据张数',
    field: 'billCount',
    align: 'center',
    width: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 1000000000,
        step: 1,
        controls: false
      },
    },
    isTotalColumn: true,
  },
]
